import { FlexBox } from 'src/ui/common/atoms/flex-box';
import styled from 'styled-components';

export const StyledShowCounterWrapper = styled(FlexBox)`
    margin: 7px 0;
    gap: 1px;
`;
